import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol
        className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm ${
          light ? "text-background-200" : "text-foreground-500"
        }`}
      >
        <li className="flex items-center gap-2">
          <Link
            to="/"
            className={`transition-colors ${
              light ? "hover:text-accent-300" : "hover:text-accent-600"
            }`}
          >
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-base opacity-60" aria-hidden="true" />
            {item.to ? (
              <Link
                to={item.to}
                className={`transition-colors ${
                  light ? "hover:text-accent-300" : "hover:text-accent-600"
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={light ? "text-background-50" : "text-foreground-800"}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}